import { module } from "modujs";
import CartApi from "../classes/StorefrontApi/CartApi/CartApi";
import VueCartTotal from "../vue/components/VueCartTotal";

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.();
    }

    updateTotal(cart) {

        if (!cart) return

        const isCheckoutAvailable = (cart.items.length > 0)

        // Update cart data
        requestAnimationFrame(() => {
            this.app && this.app.$refs.cartTotal && this.app.$refs.cartTotal.setCheckoutAvailability(isCheckoutAvailable)
            this.app && this.app.$refs.cartTotal && this.app.$refs.cartTotal.setTotalData(cart)
        })
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        // Vue.config.devtools = true;

        /////////////////////////
        // Vue Components
        VueCartTotal(moduleInstance);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }
}
